import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { EditAlt } from 'styled-icons/boxicons-regular';
import { Delete } from 'styled-icons/material';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import IconButton from '@material-ui/core/IconButton';

export default function CampusSettings({ update }) {
  const platform = useSelector((state) => state.platform);

  const [editCampus, setEditCampus] = useState({
    editing: false,
    currentIndex: 0,
    campus: '',
  });

  const HandleChangeCampus = (e) => {
    const { value } = e.target;
    setEditCampus((prevState) => ({
      ...prevState,
      campus: value,
    }));
  };

  const handleAdd = () => {
    if (editCampus.editing) {
      const tempArray = platform.platformCampus;
      tempArray[editCampus.currentIndex] = editCampus.campus;
      update({ platformCampus: tempArray });
      setEditCampus((prevState) => ({
        ...prevState,
        campus: '',
        currentIndex: 0,
        editing: false,
      }));
    } else {
      const newCampus = editCampus.campus;
      const campus = platform.platformCampus;
      campus.push(newCampus);
      update({ platformCampus: campus });
      setEditCampus((prevState) => ({
        ...prevState,
        campus: '',
        currentIndex: 0,
        editing: false,
      }));
    }
  };

  const handleEdit = (c) => {
    const found = platform.platformCampus[c];
    setEditCampus((prevState) => ({
      ...prevState,
      campus: found,
      currentIndex: c,
      editing: true,
    }));
  };

  const handleDelete = (c) => {
    const tempArray = platform.platformCampus;
    tempArray.splice(c, 1);
    update({ platformCampus: tempArray });
  };

  return (
    <div className="campusContainer">
      <div className="notificationSettings">
        <div className="configCard">
          <div className="configCardTitleCont">
            <p className="configCardTitle">Campus / Sede / Región</p>
            <p className="configCardDesc">Aquí puedes agregar los campus / sedes / regiones de tu institución</p>
          </div>
          <div className="configCardSelection">
            <div className="configCampusSelection">
              <input
                type="text"
                className="inputText"
                value={editCampus.campus}
                onChange={HandleChangeCampus}
                placeholder="Agregar campus asociados"
              />
              <button className="saveQuestion" onClick={handleAdd}>
                Guardar
              </button>
            </div>
          </div>
          <div className="listContainer">
            <List dense={false}>
              {platform.platformCampus.map((item, index) => {
                return (
                  <ListItem key={index} className="listItemCampus">
                    <p className="listText">{item}</p>
                    <ListItemSecondaryAction>
                      <IconButton aria-label="delete" onClick={() => handleDelete(index)}>
                        <Delete size={20} color="red" />
                      </IconButton>
                      <IconButton aria-label="edit" onClick={() => handleEdit(index)}>
                        <EditAlt size={20} color="#5373fc" />
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                );
              })}
            </List>
          </div>
        </div>
      </div>
    </div>
  );
}
